//@ts-check
import React from 'react';
import DropdownButton from '../../../core/DropdownButton';
import Button from '../../../core/Button';
import { useFilterContext } from './FilterContext';

var FilterAddExpression = function FilterAddExpression(_ref) {
  var _onClick = _ref.onClick,
      group = _ref.group;

  var _useFilterContext = useFilterContext(),
      disabled = _useFilterContext.disabled;

  if (group) {
    return React.createElement(DropdownButton, {
      label: "+ Add Condition",
      labelPlacement: "start",
      options: [{
        label: 'Condition',
        value: 'condition',
        onClick: function onClick() {
          return _onClick(false);
        }
      }, {
        label: 'Condition group',
        value: 'conditionGroup',
        onClick: function onClick() {
          return _onClick(true);
        }
      }],
      disabled: disabled
    });
  }

  return (// @ts-ignore
    React.createElement(Button, {
      variant: "text",
      color: "inherit",
      onClick: _onClick,
      disabled: disabled
    }, "+ Add Condition")
  );
};

export default FilterAddExpression;